import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function SingleColumnContainer(props) {
  const { children, className, ...rest} = props;

  return (
    <div
      className={cx("rec-single-column-article-container", className)}
      {...rest}>
      {children}
    </div>
  );
}

SingleColumnContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};